import { combineReducers } from 'redux';
import { navRootSaga } from './sagas';
import { navReducer } from './reducer';

const sagas = [navRootSaga];

const rootReducer = combineReducers({
    nav: navReducer
});

// @ts-expect-error
if (window.PULSE.app.redux) {
    // @ts-expect-error
    window.PULSE.app.redux.sagas.competitionNav = { root: sagas };
    // @ts-expect-error
    window.PULSE.app.redux.reducers.competitionNav = { root: rootReducer };
} else {
    // @ts-expect-error
    window.PULSE.app.redux = {
        reducers: {
            competitionNav: {
                root: rootReducer
            }
        },
        sagas: {
            competitionNav: {
                root: sagas
            }
        }
    };
}
